export function Logo({ size = 40 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt="PX7 Training"
      className="shrink-0 rounded-full"
      draggable={false}
      style={{ width: size, height: size }}
    />
  );
}

export function Wordmark() {
  return (
    <div className="flex items-center gap-3">
      <Logo size={36} />
      <div className="leading-tight">
        <div className="font-display font-bold text-px-text">PX7 Training</div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-px-text-muted">
          Science-based training
        </div>
      </div>
    </div>
  );
}
